import { message } from "antd";
import { type RcFile } from "antd/lib/upload";
import last from "lodash.last";

const ALLOWED_EXTENSIONS = [
  "txt",
  "doc",
  "docx",
  "xls",
  "xlsx",
  "ppt",
  "pptx",
  "mp3",
  "mp4",
  "csv",
  "zip",
  "jpg",
  "jpeg",
];

/** Uploaded here a video lands in Supabase storage and renders as a download link, not a player. */
const VIDEO_EXTENSIONS = ["mp4"];

export const beforeUpload = (file: RcFile, _: RcFile[], limitInMB = 40, allowVideoFiles = true) => {
  const validationType =
    file.type === "application/pdf" ||
    file.type === "image/jpg" ||
    file.type === "image/gif" ||
    file.type === "image/png";
  const extension = last(file.name.split("."));
  const allowedExtension = allowVideoFiles
    ? ALLOWED_EXTENSIONS
    : ALLOWED_EXTENSIONS.filter((ext) => !VIDEO_EXTENSIONS.includes(ext));
  // The extension is whatever the file happens to be named - a video saved as .jpg would walk
  // straight past the list, so the declared type has to be rejected too.
  const isRejectedVideo = !allowVideoFiles && file.type.startsWith("video/");

  if (isRejectedVideo || !extension || (!validationType && !allowedExtension.includes(extension))) {
    const formats = [...new Set(["jpg", "gif", "png", "pdf", ...allowedExtension])].join("/");
    void message.error(`Rozszerzenie pliku jest niedopuszczalne, wyślij plik w formacie ${formats}.`);
  }
  const isToLarge = file.size / 1024 / 1024 > limitInMB;
  if (isToLarge) {
    void message.error(`Plik nie może być większy niż ${limitInMB}MB.`);
  }

  return Boolean(
    !isRejectedVideo && (validationType || (extension && allowedExtension.includes(extension))) && !isToLarge,
  );
};
